<template>
  <div id="contenedor-subgrupos-obras">
    <v-container fluid>
      <v-card flat class="mb-4 rounded-lg">
        <v-card-text>
          <titulo-tool-bar titulo="Catálogo de Subgrupos de Obras" class="rounded-xl">
            <template v-slot:opciones-derecha>
              <v-btn
                color="primary"
                class="white--text"
                rounded
                @click="dialog = true"
              >
                <v-icon left>mdi-plus</v-icon>
                Agregar
              </v-btn>
            </template>
          </titulo-tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="listadoSubgruposObras"
            :items-per-page="5"
          >
            <template v-slot:item.acciones="{ item }">
              <v-icon
                class="mr-2"
                color="blue darken-2"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                class="mr-2"
                color="red darken-2"
                @click="catalogoSubgrupoObraEliminar = item; showDialogEliminar = true"
              >
                mdi-delete
              </v-icon>
            </template>
            <template v-slot:no-data>
              No hay subgrupos de obras registradas.
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog v-model="dialog" max-width="600px" scrollable persistent>
      <agregar-catalogo-subgrupos-obras @cerrar="cerrar" />
    </v-dialog>
    <v-dialog v-model="showDialogEliminar" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Eliminar Subgrupo de Obra</span>
        </v-card-title>
        <v-card-text>
          ¿Estás seguro de que deseas eliminar este subgrupo de obra?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="showDialogEliminar = false"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="preEliminarCatalogoSubgrupoObra(catalogoSubgrupoObraEliminar.id)"
            tipo="formAceptar"
            label="Eliminar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import TituloToolBar from '@/components/TituloToolBar.vue';
import AgregarCatalogoSubgruposObras from '@/components/administracion/configuracion/catalogos/subgrupos.obras/Agregar.vue';
import mixCatalogoSubgruposObras from '@/components/administracion/configuracion/catalogos/subgrupos.obras/mixCatalogoSubgruposObras';

export default {
  name: 'CatalogoSubgruposObrasView',
  mixins: [mixCatalogoSubgruposObras],
  components: {
    CustomButton,
    TituloToolBar,
    AgregarCatalogoSubgruposObras,
  },
  data() {
    return {
      dialog: false,
      showDialogEliminar: false,
      catalogoSubgrupoObraEliminar: {},
      catalogoSubgrupoObraEditar: {},
      headers: [
        { text: 'Grupo de Obra', value: 'grupoObra.descripcion' },
        { text: 'Número', value: 'numero' },
        { text: 'Descripción', value: 'descripcion' },
        {
          text: 'Acciones', value: 'acciones', sortable: false, width: '200px',
        },
      ],
    };
  },
  methods: {
    async preEliminarCatalogoSubgrupoObra(id) {
      await this.mixEliminarCatalogoSubgrupoObra(id).then(() => {
        this.catalogoSubgrupoObraEliminar = {};
        this.showDialogEliminar = false;
      });
    },
    cerrar() {
      this.dialog = false;
    },
  },
  computed: {
    listadoSubgruposObras() {
      if (!this.catalogoSubgruposObras) {
        return [];
      }
      return this.catalogoSubgruposObras;
    },
  },
};
</script>

<style lang="scss">

</style>
